import { useEffect, useState } from "react";

export const useVacancy = () => {
  const [jobVacancyJsonz, setJobVacancyJson] = useState<any>();
  const [category, setCategory] = useState<any>();
  const vacancyService = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      };

      const response = await fetch(
        `https://recruitment.lon1.cdn.digitaloceanspaces.com/assets/table-memory-storage/dataset/vacancy.json`,
        {
          method: 'GET',
          headers,
        }
      );

      // 1. Check for HTTP errors (Axios does this automatically, Fetch does not)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 2. Parse the JSON manually
      const jsonData = await response.json();

      // 3. Process data (Replace 'response.data' with 'jsonData')
      const categoryData = Object.assign(
        {},
        ...Object.values(jsonData.dataset?.category)
      );

      setCategory(categoryData);
      setJobVacancyJson(jsonData);
    } catch (error) {
      console.error('Error fetching job vacancies:', error);
      return null;
    }
  };

  useEffect(() => {
  // fetchNotice();
    vacancyService();
  }, []);

  return { jobVacancyJsonz, category }
}
